import Constants from '@/Constants';
import React from 'react';
import './style.scss';

interface PropsType {
    value: boolean;
    handleClick: (value: boolean) => void;
}

const AfChecked = ({ value, handleClick }: PropsType) => {
    return (
        <div className="af-check" onClick={() => handleClick(!value)}>
            {value ? (
                <i className="material-icons check-icon">{Constants.icons.CHECK_CIRCLE}</i>
            ) : (
                <i className="material-icons check-icon">{Constants.icons.UNCHECK_CIRCLE}</i>
            )}
        </div>
    );
};

export default AfChecked;
